export const defaultLocale = {
    name: "default",
    conversions: {
        fromMeters: (input) => {
            return (input / 1609.344);
        },
        toMeters: (input) => {
            return (input * 1609.344);
        },
    },
    strings: {
        zip: "Zip",
        state: "State",
        distanceUnit: "mile",
        distanceUnitPlural: "miles",
    },
};
export const klingon = {
    name: "klingon",
    conversions: {
        fromMeters: (input) => {
            return (input * 2);
        },
        toMeters: (input) => {
            return (input / 2);
        },
    },
    strings: {
        zip: "voDmoH",
        state: "Hew",
        distanceUnit: "jIH",
        distanceUnitPlural: "qeylIS",
    },
};
//# sourceMappingURL=default.js.map